<template>
     <div class="tenantagreement-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Contract Detailing" 
                />
          <b-card class="tenantagreement-search-card">
       
                    <b-tabs card vertical >
                        <b-tab title="Contract Detail" active>
                        <b-form>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            :per-page="perPage" 
                            :current-page="currentPageFinancial" 
                            head-variant="light" 
                            :items="tenantagreementfinancialdetails" 
                            :fields="fielsFinancial">
                            <template v-slot:cell(actions)="data">
                                <b-button 
                                title="Agreement" 
                                size="sm" 
                                variant="light" 
                                @click="[printerAgreement(data.item)]" 
                                class="mr-2 mt-2">
                                <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                                 <b-button
                                    title = "Access Platform"
                                    size="sm"
                                    @click="[setPassport(data.item),openModalPlatformAccess()]"
                                    variant="light"
                                    class="mr-2 mt-2 fa fa-info-circle"
                                    > 
                                </b-button>
                                <b-button 
                                    title="Open List Rules" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[setPassport(data.item),loadRules(),openModalImmobileRuleTable()]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-list-alt"></i>
                                </b-button>
                                <b-button
                                    title = "Attachment Signed Document"
                                    size="sm"
                                    @click="setPassport(data.item)"
                                    variant="light"
                                    class="mr-2 mt-2 fa fa-plus"
                                    v-b-modal.modalFile
                                    > 
                                </b-button>
                                <b-button
                                    title="View Signed Doc."
                                        size="sm"
                                        variant="light"
                                        v-if="data.item.storege_id_doc_signed_agreement > 0"
                                        @click="loadUrl(data.item)"
                                        class="mr-2 mt-2"
                                    >
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                                 <b-button
                                    title="Assignment Doc."
                                        size="sm"
                                        variant="light"
                                        v-if="data.item.storege_id_doc_signed_agreement > 0"
                                        @click="modifyPdf(data.item)"
                                        class="mr-2 mt-2"
                                    >
                                    <i class="fa fa-file-text"></i>
                                </b-button>
                             </template>
                        </b-table>
                        </transition>   
                        <b-pagination
                           v-show="showTable"
                            v-model="currentPageFinancial"
                            :total-rows="rowsFinancial"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>                          
                            </b-row>
                        </b-form>
                        </b-tab >
                    </b-tabs>         
                </b-card>   
        <b-modal
            id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveDocAssignment"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>  
      <b-modal
            id="modalPlatformAccess"
            ref="modal"
            title-tag="h6"
            title="Utillities Informations"
            hide-footer
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                     <b-col md="12" sm="12">
                        <b-link :href="tenantagreement.gas_url_site_immobile">Url Gas</b-link>
                     </b-col>
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                         <b-form-group 
                                label="Card Number:" 
                                label-for="tenantagreement-gas_contract_immobile">
                            <b-form-input id="tenantagreement-gas_contract_immobile" 
                                type="text"
                                :readonly="true"
                                v-model="tenantagreement.gas_contract_immobile" 
                                size="sm"
                                placeholder="Gas Card Number..." />
                        </b-form-group>
                     </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Login:" 
                                label-for="tenantagreement-gas_login_immobile">
                            <b-form-input id="tenantagreement-gas_login_immobile" 
                                type="text"
                                v-model="tenantagreement.gas_login_immobile" 
                                :readonly="true"
                                size="sm"
                                placeholder="Login Gas..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                      <b-col md="12" sm="12">
                        <b-form-group 
                                label="Password:" 
                                label-for="tenantagreement-gas_password_immobile">
                            <b-form-input id="tenantagreement-gas_password_immobile" 
                                type="text"
                                v-model="tenantagreement.gas_password_immobile" 
                                :readonly="true"
                                size="sm"
                                placeholder="Password Gas..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <br>
                <b-row>
                     <b-col md="12" sm="12">
                        <b-link :href="tenantagreement.energy_url_site_immobile">Url Electricity</b-link>
                     </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Card Number:" 
                                label-for="tenantagreement-energy_contract_immobile">
                            <b-form-input id="tenantagreement-energy_contract_immobile" 
                                type="text"
                                :readonly="true"
                                v-model="tenantagreement.energy_contract_immobile" 
                                size="sm"
                                placeholder="Card Number..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Login :" 
                                label-for="tenantagreement-energy_login_immobile">
                            <b-form-input id="tenantagreement-energy_login_immobile" 
                                type="text"
                                v-model="tenantagreement.energy_login_immobile" 
                                  :readonly="true"
                                size="sm"
                                placeholder="Login Electricity..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                        <b-form-group 
                                label="Password:" 
                                label-for="tenantagreement-energy_password_immobile">
                            <b-form-input id="tenantagreement-energy_password_immobile" 
                                type="text"
                                 :readonly="true"
                                v-model="tenantagreement.energy_password_immobile" 
                                size="sm"
                                placeholder="Password Electricity..." />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
          <b-modal
            id="modalTenantImmobileRuleTable"
            ref="modal"
            title-tag="h6"
            title="Rules"
            hide-footer
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                 <b-table 
                    class="table-responsive" 
                    hover 
                    key="slide"  
                    head-variant="light" 
                    :items="immobilerules" 
                    :fields="fieldImmobileRule">
                </b-table>
            </b-form>
        </b-modal>
     </div>
     
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import { degrees, PDFDocument, rgb, StandardFonts} from 'pdf-lib'

var moment = require('moment-timezone')
var download = require('downloadjs')

export default {
    name: 'TenantContract',
    components: {PageTitle},
    data: function() {
        return {
                mode: 'insert',
                search: '',
                tenantagreementfinancialdetail:{},
                tenantagreement:{},
                tenantagreementfinancialdetails:[],
                immobilerules:[],    
                perPage: 20,
                currentPage: 1,
                pdfBytes: null,
                currentPageFinancial: 1,
                currentPageFinancialSearch: 1,
                 isBusy: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
             
                fielsFinancial:[
                      {
                        key: 'agreement_date',label: 'Agreement Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                     { key: 'active_agreement', label: 'Active', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},
                    { key: 'name_tenant', label: 'Tenant Name', sortable: false ,variant: 'light'},
                    { key: 'address_immobile', label: 'Address', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'contract_value_agreement', label: 'Value Agreement', sortable: true ,variant: 'light'},
                    { key: 'deposit_amount_agreement', label: 'Deposit Amount', sortable: true ,variant: 'light'},
                    { key: 'contract_months_agreement', label: 'Agreement Months', sortable: false,variant: 'light'},
                     {
                        key: 'approval_date_agreement',label: 'Approval Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    }, 
                    {
                        key: 'date_end_agreement',label: 'End Contract ',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },  
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
                fieldImmobileRule:[
                      { key: 'description_rule', label: 'Description', sortable: false ,variant: 'light'},
                ],
                
                 optionsPayment: [
                    { item: 1, name: 'Cash' },
                    { item: 2, name: 'Bank Transfer' }
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rowsFinancial() {
                return this.tenantagreementfinancialdetails.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{

            async modifyPdf(item) {
                const url = item.url_file
                const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

                const pdfDoc = await PDFDocument.load(existingPdfBytes)
                const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

                const pages = pdfDoc.getPages()
                const firstPage = pages[1]
                //const { width, height } = firstPage.getSize()
                firstPage.drawText(`${item.name_tenant}`, {
                    x: 60,
                    y: 60,
                    // height / 2 + 300,
                    size: 20,
                    font: helveticaFont,
                    color: rgb(0.95, 0.1, 1),
                    rotate: degrees(0),
                })

                   const pdfBytes = await pdfDoc.save()
                    
                    download( pdfBytes, item.name_file, "application/pdf")

                    
                },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            returnOptionFinancial(value) {

                   let descrition_task = ''

                    if(value ===1)
                    {
                        descrition_task = 'Cash'
                    }
                    else if(value === 2)
                    {
                        descrition_task = 'Bank Transfer'
                    }


                return descrition_task
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/tenantagreementsbyuser/${this.user.id}`
                axios(url).then(res =>{
                     this.tenantagreementfinancialdetails = res.data
                })
            },
            async printerPaymentReceipt(item) {
    
            const url = `${baseApiUrl}/tenantpaymentreceiptprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            openModalImmobileRuleTable(){
                this.$bvModal.show('modalTenantImmobileRuleTable')
            },
            openModalPlatformAccess() {
                this.$bvModal.show('modalPlatformAccess')
            },
            async printerAgreement(item) {
    
            const url = `${baseApiUrl}/tenantagreementprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },

            async saveFinancial() {

                    if(!this.tenantagreementfinancialdetail.id > 0){
                        this.tenantagreementfinancialdetail.company_id_financial_detail = this.compan.id
                        this.tenantagreementfinancialdetail.tenant_agreement_id_financial_detail = this.tenantagreement.id

                    }
             
                    const method = this.tenantagreementfinancialdetail.id ? 'put' : 'post'
                    const id = this.tenantagreementfinancialdetail.id ? `/${this.tenantagreementfinancialdetail.id}` : ''
                    await axios[method](
                        `${baseApiUrl}/altertenantagreementfinancialdetails${id}`,
                        this.tenantagreementfinancialdetail
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.tenantagreementfinancialdetail = {}
                            this.loadFinancialDetail()
                 
                        })
                        .catch(showError)
            },
            async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
                async getLastStorageFile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                    await axios(url).then(
                        (res) =>
                        (this.tenantagreement = {
                            ...this.tenantagreement,
                            storege_id_doc_signed_agreement: res.data.id,
                        })
                    );
                },  
                loadUrl(item){
                    window.open(item.url_file, '_blank')
                }, 
                loadRules(){
                    const url = `${baseApiUrl}/immobilerulesbyid/${this.tenantagreement.ower_immobile_id_agreement}`
                    axios(url).then(res =>{
                        this.immobilerules = res.data
                    })
                },
                setPassport(tenantagreement){
                 this.tenantagreement = { ...tenantagreement }
                },
                async save() {

                const method = this.tenantagreement.id ? 'put' : 'post'
                const id = this.tenantagreement.id ? `/${this.tenantagreement.id}` : ''

                await axios[method](`${baseApiUrl}/tenantagreements${id}`, this.tenantagreement)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadFinancialDetail()
                    })
                    .catch(showError)
            },
              async saveDocAssignment() {

                const method = this.tenantagreement.id ? 'put' : 'post'
                const id = this.tenantagreement.id ? `/${this.tenantagreement.id}` : ''

                await axios[method](`${baseApiUrl}/tenantagreementsdocassignment${id}`, this.tenantagreement)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadFinancialDetail()
                    })
                    .catch(showError)
            },

        },
        mounted(){

                this.start_date = moment()
                .add(-30, "d")
                .format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadFinancialDetail()
            this.showTable = true
        }
}
</script>

<style>


    .tenantagreement-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .tenantagreement-search button{
        font-size: 0.75rem;
    }

     .tenantagreement-search select{
        font-size: 0.75rem;
    }

    .tenantagreement-search input{
        font-size: 0.75rem;
    }

    .tenantagreement-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalPlatformAccess {
        font-size: 0.75rem;
    }

    #modalPlatformAccess button{
        font-size: 0.75rem;
    }

     #modalPlatformAccess input{
        font-size: 0.75rem;
    }

      #modalPlatformAccess label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
